import React from 'react';
import CustomBox from '../CommonComp/CustomBox/CustomBox';
import AllJobWorkList from './AllJobWorkList';

function JobworkTabBody({ activeTab }) {
  return (
    <CustomBox
      padding={0}
      sx={{
        minHeight: 200,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {activeTab == 1 && <AllJobWorkList />}
    </CustomBox>
  );
}

export default JobworkTabBody;
